/** 与 OrderApprovalReasonDetail / 后端 placement triggers 口径一致 */
export const APPROVAL_TRIGGER_LABELS = {
	belowMinimumPrice: '产品销售价格低于底价',
	partialPayment: '支付方式为部分支付',
	creditOverdue: '额度支付有单笔超期',
};

/**
 * 待审批列表用：从 approval.detail.triggers / reason 得到审批原因文案。
 * @returns {string[]}
 */
export const getApprovalTriggerSummaryLines = (approval) => {
	if (!approval || typeof approval !== 'object') return [];

	const detail = approval.detail && typeof approval.detail === 'object' ? approval.detail : null;
	const triggers = Array.isArray(detail?.triggers) ? detail.triggers : [];

	if (triggers.length > 0) {
		return triggers.map((key) => APPROVAL_TRIGGER_LABELS[key]).filter(Boolean);
	}

	if (detail?.adjustmentType === 'finalCost') {
		return ['最终成本修正'];
	}

	const reasonHtml = String(approval.reason || '');
	if (!reasonHtml) return [];

	const lines = [];
	if (/低于底价/.test(reasonHtml)) lines.push(APPROVAL_TRIGGER_LABELS.belowMinimumPrice);
	if (/部分支付/.test(reasonHtml)) lines.push(APPROVAL_TRIGGER_LABELS.partialPayment);
	if (/单笔超期/.test(reasonHtml)) lines.push(APPROVAL_TRIGGER_LABELS.creditOverdue);
	if (/最终成本/.test(reasonHtml)) lines.push('最终成本修正');
	return lines;
};

export const formatApprovalTriggerSummary = (approval) => getApprovalTriggerSummaryLines(approval).join('；');

const stripApprovalTitlePrefix = (title) =>
	String(title || '')
		.replace(/^\[[^\]]+\]\s*/, '')
		.replace(/^订单\s+/, '')
		.trim();

/**
 * 待办列表审批事项：类型徽章 + 可点主体（订单号 / 客户名）。不改库内 title。
 * @returns {{ label: string, bg: string, subject: string }}
 */
export const getPendingApprovalKind = (row) => {
	const approval = row?.approval && typeof row.approval === 'object' ? row.approval : null;
	const detail = approval?.detail && typeof approval.detail === 'object' ? approval.detail : {};
	const rawTitle = String(approval?.title || row?.title || '');

	if (row?.entryKind === 'customer') {
		return {
			label: '客户添加',
			bg: 'info',
			subject: row?.customerInfo?.customerName || detail.newCustomerConcatName || stripApprovalTitlePrefix(rawTitle),
		};
	}

	if (row?.entryKind === 'quota') {
		const temporary = detail.quotaKind === 'temporary' || rawTitle.includes('临时额度');
		return {
			label: temporary ? '临时额度' : '永久额度',
			bg: temporary ? 'warning' : 'success',
			subject:
				row?.customerInfo?.customerName ||
				detail.customerName ||
				rawTitle.replace(/-(永久|临时)额度申请$/, '').trim(),
		};
	}

	const subject = detail.orderId || row?.orderId || stripApprovalTitlePrefix(rawTitle);
	if (detail.adjustmentType === 'finalCost' || /最终成本/.test(rawTitle)) {
		return { label: '成本修正', bg: 'warning', subject };
	}
	return { label: '订单审批', bg: 'primary', subject };
};
